import { render, staticRenderFns } from "./DynamicListWrapper.vue?vue&type=template&id=5c628113&"
import script from "./DynamicListWrapper.vue?vue&type=script&lang=js&"
export * from "./DynamicListWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c628113')) {
      api.createRecord('5c628113', component.options)
    } else {
      api.reload('5c628113', component.options)
    }
    module.hot.accept("./DynamicListWrapper.vue?vue&type=template&id=5c628113&", function () {
      api.rerender('5c628113', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-wrapper/DynamicListWrapper.vue"
export default component.exports